export const REQUEST_LOADING = 'appointments/loading';
export const REQUEST_SUCCESS = 'appointments/success';
export const REQUEST_FAILURE = 'appointments/failure';
export const ALL_APPOINTMENTS = 'appointments/all';
export const APPOINTMENT_DELETE = 'appointments/delete';
